(($) => {
    $(document).ready(function (e) {
        $('#submit_paypal').on('click', function (e) {
            let dataLoadComplete = new Event('dataLoadComplete');

            if (!$('.input-shipping-type').is(':checked')) {
                $('#error-select-shipping').fadeIn();
                $('form.checkout-form').scrollTop(0);

                return false;
            }
            const quantity = Number($('input#product_qty').val());
            if (isNaN(quantity) || quantity < 1) {
                $('#error-quantity').fadeIn();
                $('form.checkout-form').scrollTop(0);
                return false;
            }

            let $userForm = $('#checkout_form');
            window.bhWP.prepareToDataLoad();

            let paypalData = {
                first_name: $userForm.find('[name=first_name]').val(),
                last_name: $userForm.find('[name=last_name]').val(),
                email: $userForm.find('[name=email]').val(),
                state: $userForm.find('[name=state]').val(),
                state_code: window.bhWP.stateCode,
                city: $userForm.find('[name=city]').val(),
                address_line1: $userForm.find('[name=address_line1]').val(),
                address_line2: $userForm.find('[name=address_line2]').val(),
                phone: $userForm.find('[name=phone]').val(),
                zip: $userForm.find('[name=zip]').val(),
                product_id: $userForm.find('[name=product_id]').val(),
                shipping: $userForm.find('[name=shipping]:checked').val(),
                applied_coupon: $userForm.find('[name=applied_coupon]').val(),
                quantity: $userForm.find('[name=quantity]').val(),

                country_id: window.bhWP.selectedCountry.country_id,
                country: $userForm.find('[name=country]').val(),
                country_code: window.bhWP.selectedCountry.country_code,

                _wpnonce: wp.pp_nonce,
            };

            paypalData.action = 'bhop_paypal_redirect';
            paypalData['current_page'] = window.location.href;

            $.post(wp.ajax_url, paypalData, () => {}, 'json')
                .done((resp) => {
                    if (!resp.result) {
                        document.body.dispatchEvent(dataLoadComplete);

                        return false;
                    }

                    const orderInfo = resp.order_info;

                    tap('conversion', orderInfo.order_id, orderInfo.price_without_ship, {
                        currency: orderInfo.currency,
                    });
                    window.location.href = resp.redirect;
                })
                .fail(function () {
                    document.body.dispatchEvent(dataLoadComplete);
                });

            // $.extend(
            //     {
            //         redirectPost: function(location, args)
            //         {
            //             var form = $('<form></form>');
            //             form.attr("method", "post");
            //             form.attr("action", location);

            //             $.each( args, function( key, value ) {
            //                 var field = $('<input></input>');

            //                 field.attr("type", "hidden");
            //                 field.attr("name", key);
            //                 field.attr("value", value);

            //                 form.append(field);
            //             });
            //             $(form).appendTo('body').submit();
            //         }
            //     });

            // $.redirectPost(wp.website_url + "/paypal", paypalData, "POST");

            // $ppForm.submit();
        });
    });
})(jQuery);
